import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { IQuestionAnswerPagedRequest } from '../../../../model/apm/question-answer/request/question-answer-paged-request';
import { IQuestionAnswerAddEditRequest } from '../../../../model/apm/question-answer/request/question-answer-add-edit-request';
import { IQuestionAnswerCategoryAddEditRequest } from '../../../../model/apm/question-answer/request/question-answer-category-add-edit-request';
import { IQuestionAnswerResponse } from '../../../../model/apm/question-answer/response/question-answer-response';
import { IQuestionAnswerCategoryResponse } from '../../../../model/apm/question-answer/response/question-answer-category-response';

const defaultPath = 'QuestionAnswer';

// Paginação 0-based; a API limita PageSize a 100
const list = async (params: IQuestionAnswerPagedRequest): Promise<Pagination<IQuestionAnswerResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params: {
            Term: params.term || undefined,
            CategoryId: params.categoryId,
            Page: params.page,
            PageSize: params.pageSize,
        }
    }).then((response) => Object.assign(new Pagination<IQuestionAnswerResponse>(), response.data));
};

const getById = async (id: number): Promise<IQuestionAnswerResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: IQuestionAnswerAddEditRequest): Promise<IQuestionAnswerResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: params
    }).then((response) => response.data);
};

const edit = async (id: number, params: IQuestionAnswerAddEditRequest): Promise<IQuestionAnswerResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params
    }).then((response) => response.data);
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

const listCategories = async (): Promise<IQuestionAnswerCategoryResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Category`
    }).then((response) => response.data || []);
};

const addCategory = async (params: IQuestionAnswerCategoryAddEditRequest): Promise<IQuestionAnswerCategoryResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/Category`,
        data: params
    }).then((response) => response.data);
};

const editCategory = async (categoryId: number, params: IQuestionAnswerCategoryAddEditRequest): Promise<IQuestionAnswerCategoryResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/Category/${categoryId}`,
        data: params
    }).then((response) => response.data);
};

const removeCategory = async (categoryId: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/Category/${categoryId}`
    });
};

const QuestionAnswerAppService = {
    list, getById, add, edit, remove,
    listCategories, addCategory, editCategory, removeCategory
};
export default QuestionAnswerAppService;
